import { render, staticRenderFns } from "./MoreDestinations.vue?vue&type=template&id=1e20a832&scoped=true"
import script from "./MoreDestinations.vue?vue&type=script&lang=js"
export * from "./MoreDestinations.vue?vue&type=script&lang=js"
import style0 from "./MoreDestinations.vue?vue&type=style&index=0&id=1e20a832&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e20a832",
  null
  
)

export default component.exports